/**
 * @description ProductDescriptionItem widget implementation.
 * It is used for handling product's description section
 * @param {Widget} Widget Base widget for extending
 * @returns {typeof ProductDescriptionItem} - ProductDescriptionItem class
 */
const keyCode = Object.freeze({
    SPACE: 32,
    ENTER: 13
});

const eventType = Object.freeze({
    CLICK: 'click',
    KEYDOWN: 'keydown'
});

export default function (Widget) {
    return class ProductDescriptionItem extends Widget {
        prefs() {
            return {
                hiddenClass: 'm-hidden',
                collapsedClass: 'm-collapsed',
                ...super.prefs()
            };
        }

        toggleContent(isVisible) {
            this.ref('self').toggleClass(this.prefs().collapsedClass);
            this.ref('expandable-item')
                .toggleClass(this.prefs().hiddenClass)
                .attr('aria-hidden', `${isVisible}`);
            this.ref('controlButton').attr('aria-expanded', `${!isVisible}`);
        }

        /**
         * @description Handle triggering `view more` / `view less` links
         */
        handleMoreLessLinks(_el, event) {
            let preventEventActions = false;
            const isExpanded = this.ref('controlButton').attr('aria-expanded') === 'true';

            switch (event.type) {
                case eventType.CLICK:
                    this.toggleContent(isExpanded);
                    break;
                case eventType.KEYDOWN:
                    if (event.keyCode === keyCode.SPACE || event.keyCode === keyCode.ENTER) {
                        this.toggleContent(isExpanded);
                        preventEventActions = true;
                    }
                    break;
                default:
                    return;
            }

            if (preventEventActions) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
    };
}
